import React, { Fragment } from 'react';
import Articulos from './detalleArticulo.jsx';

const fontStyles = { fontSize: '14px', fontFamily: 'monospace' };
const paragraphStyles = { lineHeight: '1.5' };

const encabezadoImp = props => {

    const { articulos, tipoEntrega, R_Disponible, Re_Impreso, ParametroGenerales, OrdenId, Disponible_Positivo, empresa_nombre, instrucciones_entrega } = props;
    const sucursal = articulos[0];
    const reImpreso = Re_Impreso ? <p>******* COPIA *******</p> : null;
    const observaciones = sucursal.Orden_Observaciones.length > 0 ? <Fragment><br />{`Observaciones: ${sucursal.Orden_Observaciones}`}</Fragment> : null;
    const movInventario = sucursal.Suc_Id !== sucursal.Sucursal_Factura ? <p>{`Mov. Invent: Bodega: ${sucursal.Suborden_Mov_Bodega}, Mov: ${sucursal.Suborden_Mov_Id}`}</p> : null;

    const contenidoHtml = articulos.length > 0 ?
        <Fragment>
            <div style={{ ...fontStyles, textAlign: "center" }}>
                <p style={paragraphStyles}><b>{empresa_nombre}</b></p>
            </div>
            <div style={fontStyles}>
                <p style={paragraphStyles}>
                    {sucursal.Suc_Nombre}<br />
                    {`Orden: ${OrdenId}`}<br />
                    {`Fecha: ${sucursal.Orden_Fin_RegistroStr}`}<br />
                    {`Tiempo Disponible: ${Disponible_Positivo ? "+" : "-"} ${R_Disponible}`}
                </p>
                <hr style={{ borderWidth: "1px", borderStyle: "dashed", marginTop: '1rem', marginBottom: '1rem' }} />
                {reImpreso}
                <p style={paragraphStyles}>
                    {`Teléfono: ${sucursal.Ubicacion_Id}`}<br />
                    {`Nombre: ${sucursal.Ubicacion_Nombre}`}<br />
                    {tipoEntrega === 'PU' ?
                        'Cliente Recoge en Tienda'
                        : <Fragment>
                            {'Entrega a Domicilio'}<br />
                            {`${ParametroGenerales.Nivel1_name}: ${sucursal.Nivel1_Nombre}`}<br />
                            {`${ParametroGenerales.Nivel2_name}: ${sucursal.Nivel2_Nombre}`}<br />
                            {`${ParametroGenerales.Nivel3_name}: ${sucursal.Nivel3_Nombre}`}<br />
                            {`${ParametroGenerales.Nivel4_name}: ${sucursal.Nivel4_Nombre}`}<br />
                            {`Dirección: ${sucursal.Ubicacion_Barrio} ${sucursal.Ubicacion_Senas}`}
                            {observaciones}
                        </Fragment>
                    }
                    {
                        instrucciones_entrega ?
                            <>
                                <hr style={{ borderWidth: "1px", borderStyle: "dashed", marginTop: '1rem', marginBottom: '1rem' }} />
                                Instrucciones de Entrega<br />
                                <p style={{ overflowWrap: "break-word" }}>{instrucciones_entrega}</p>
                            </>
                            : null
                    }
                </p>
                {movInventario}
                <hr style={{ borderWidth: "1px", borderStyle: "dashed", marginTop: '1rem', marginBottom: '1rem' }} />
            </div>
        </Fragment>
        : null;
    return (
        <Fragment>
            {contenidoHtml}
            <Articulos articulos={articulos} />
        </Fragment>
    );
}

export default encabezadoImp;
